<template>
<div>
    <h1 class="mb-4 text-gray-500">xHamster Downloader</h1>

    <client-only>
        <template #fallback>
            <el-card shadow="never" :body-style="{padding: '0'}" class="mb-4">
                <div style="height: 100px" class="flex items-center justify-center">
                    <ElIconLoading :width="20" class="mr-2"/>
                    Loading the app
                </div>
            </el-card>
        </template>
        <downloader></downloader>
    </client-only>
    <el-card shadow="never" class="mb-4" :body-style="{ padding: '20px' }">
        <h2 class="text-2xl mb-4">
            Demo video
        </h2>
        <div class="mb-4"> Learn how to get started with xHamster downloader by watching the demo video </div>
        <el-button type="info" size="large" :icon="ElIconVideoPlay" @click="showDemoVideo = true" v-if="!showDemoVideo">Watch video</el-button>

        <video controls autoplay="false" v-show="showDemoVideo">
            <source src="https://anyloader.com/onlyfans_downloader_demo.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
    </el-card>

    <xhamster-faq></xhamster-faq>
</div>
</template>
<script>
export default {
    created() {
        const siteUrl = useRuntimeConfig().public.siteUrl
        const faqStructuredData = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
                {
                    '@type': 'Question',
                    name: 'What is xHamster Downloader?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'xHamster Downloader is a free tool that lets you download videos from xHamster for offline viewing. Save videos in high quality to watch later without an internet connection.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'How does xHamster Downloader work?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'The xHamster video downloader works through a Chrome browser extension. After installing the extension, simply paste the xHamster video URL into the downloader, and it will extract the video file for you to download.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'Is it safe to use xHamster Downloader?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Yes, our xHamster Downloader is safe to use. The Chrome extension operates entirely in your browser and doesn\'t require any software installation on your computer. Your downloads remain private.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'Can I download xHamster videos in HD quality?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Yes, you can download xHamster videos in their original quality, including HD and Full HD resolutions when available. The downloader preserves the video quality as uploaded.'
                    }
                }
            ]
        }

        useHead({
            title: 'Free xHamster Downloader - Download Videos from xHamster',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Download videos from xHamster for free using our Chrome extension. Save videos in HD quality for offline viewing. Fast, safe, and easy to use.',
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: 'xhamster downloader, download xhamster videos, xhamster video downloader, free xhamster downloader, xhamster chrome extension'
                }
            ],
            link: [
                {rel: 'canonical', href: siteUrl + '/xhamster-downloader'}
            ],
            script: [
                {
                    type: 'application/ld+json',
                    children: JSON.stringify(faqStructuredData)
                }
            ]
        })
    },
    data () {
        return {
            showDemoVideo: false
        }
    }
}
</script>
